import { render, staticRenderFns } from "./system-config-sidebar.vue?vue&type=template&id=e06e16b2&"
import script from "./system-config-sidebar.vue?vue&type=script&lang=js&"
export * from "./system-config-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e06e16b2')) {
      api.createRecord('e06e16b2', component.options)
    } else {
      api.reload('e06e16b2', component.options)
    }
    module.hot.accept("./system-config-sidebar.vue?vue&type=template&id=e06e16b2&", function () {
      api.rerender('e06e16b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/system-config-sidebar.vue"
export default component.exports